// extracted by css-extract-rspack-plugin
export default {"CircleBadge":"MarketplaceListings-module__CircleBadge__oqv3H","svgAvatar":"MarketplaceListings-module__svgAvatar__STLYB"};